module.exports = __webpack_public_path__ + "media/stop-10.d915fc8b.mp3";